// @flow
import mediatorChannels from "@tvg/mediator";
import { get } from "lodash";
import pushToDataLayer from "../gtmUtils";

type GTMDerbyHeaderClick = {
  type: "DERBY_HEADER_CLICK",
  payload: {
    linkText: string,
    linkUrl?: string,
    bannerId: string,
    bannerName: string
  }
};

type GTMDerbyHeaderSelectedRace = {
  type: "DERBY_HEADER_SELECTED_RACE",
  payload: {
    linkText: string,
    bannerId: string,
    bannerName: string
  }
};

type GTMDerbyHeaderViewed = {
  type: "DERBY_HEADER_VIEWED",
  payload: {
    bannerId: string,
    bannerName: string
  }
};

export default () => {
  mediatorChannels.base.subscribe(
    "DERBY_HEADER_CLICK",
    (data: GTMDerbyHeaderClick) => {
      pushToDataLayer({
        event: "banner",
        gaEventCategory: "Banner",
        gaEventAction: "Banner Link Clicked",
        gaEventLabel: get(data, "payload.linkText"),
        module: "derby_banner",
        linkUrl: get(data, "payload.linkUrl"),
        bannerType: "derby",
        bannerId: "homepage/homepage-config",
        bannerName: get(data, "payload.bannerName"),
        linkText: get(data, "payload.linkText")
      });
    }
  );

  mediatorChannels.base.subscribe(
    "DERBY_HEADER_SELECTED_RACE",
    (data: GTMDerbyHeaderSelectedRace) => {
      pushToDataLayer({
        event: "banner",
        gaEventCategory: "Banner",
        gaEventAction: "Banner Link Clicked",
        gaEventLabel: "race_selected",
        module: "derby_banner",
        linkUrl: get(data, "payload.linkUrl"),
        bannerType: "derby",
        bannerId: "homepage/homepage-config",
        bannerName: get(data, "payload.bannerName"),
        linkText: "race_selected"
      });
    }
  );

  mediatorChannels.base.subscribe(
    "DERBY_HEADER_VIEWED",
    (data: GTMDerbyHeaderViewed) => {
      pushToDataLayer({
        event: "banner",
        gaEventCategory: "Banner",
        gaEventAction: "Banner Viewed",
        gaEventLabel: "derby_banner",
        module: "derby_banner",
        bannerType: "derby",
        bannerId: "homepage/homepage-config",
        bannerName: get(data, "payload.bannerName"),
        linkText: undefined
      });
    }
  );
};
